var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('configurator',{class:[
      this.$store.state.showConfig ? 'show' : '',
      
    ],attrs:{"toggle":_vm.toggleConfigurator}}),_c('character-panel',{class:[
      this.$store.state.showCharacterPanel ? 'show' : '',
      
    ],attrs:{"toggle":_vm.toggleCharacterPanel}}),_c('environment-panel',{class:[
      this.$store.state.showEnvironmentPanel ? 'show' : '',
      
    ],attrs:{"toggle":_vm.toggleEnvironmentPanel}}),_c('slides-panel',{class:[
      this.$store.state.showSlidesPanel ? 'show' : '',
      
    ],attrs:{"toggle":_vm.toggleSlidesPanel}}),_c('camera-panel',{class:[
      this.$store.state.showCameraPanel ? 'show' : '',
      
    ],attrs:{"toggle":_vm.toggleCameraPanel}}),_c('recording-panel',{class:[
      this.$store.state.showRecordingPanel ? 'show' : '',
      
    ],attrs:{"toggle":_vm.toggleRecordingPanel}}),(this.$store.state.showSidenav&&this.$store.state.showNavs)?_c('sidenav',{attrs:{"is-blur":"blur blur-rounded my-3 py-2 start-0 end-0 mx-4 shadow"}}):_vm._e(),(this.$store.state.showNavs)?_c('div',[(!this.$store.state.showSidenav)?_c('div',{staticClass:"fixed-plugin",staticStyle:{"position":"absolute","top":"0","left":"0","z-index":"10","margin":"35px"}},[_c('a',{staticClass:"px-1 py-2 fixed-plugin-button text-dark",staticStyle:{"background-color":"rgba(255,255,255,0.6)"},on:{"click":_vm.showNavbar}},[_c('img',{staticClass:"navbar-brand-img h-50",attrs:{"src":_vm.logo,"width":"35","height":"35","alt":"main_logo"}})])]):_vm._e()]):_vm._e(),_c('main',{staticClass:"main-content position-relative max-height-vh-100 h-100 border-radius-lg"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }